import { TwinfieldTestService } from '../../../services/twinfieldTest.service';

class TwinfieldTestController implements ng.IComponentController {
    private endpoints: any[] = [];
    private selectedEndpoint: any = null;
    private endpointParams: any = {};
    private result: any = null;
    private loading: boolean = false;
    private error: string = null;

    constructor(
        private TwinfieldTestService: TwinfieldTestService
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.endpoints = [
            {
                name: 'Get Employee Cost Center',
                method: 'GET',
                path: 'employee/{employeeId}/costcenter',
                description: 'Haal Twinfield costcenter(s) op voor 1 Operando employee.',
                params: [
                    { key: 'employeeId', label: 'Employee Id (GUID)', type: 'text', value: null }
                ]
            },
            {
                name: 'Create Employee Cost Center',
                method: 'GET',
                path: 'employee/{employeeId}/costcenter/create',
                description: 'Maak Twinfield costcenter aan als deze nog niet bestaat.',
                params: [
                    { key: 'employeeId', label: 'Employee Id (GUID)', type: 'text', value: null }
                ]
            },
            {
                name: 'Sync Employee Cost Center',
                method: 'GET',
                path: 'employee/{employeeId}/costcenter/sync',
                description: 'Check en maak indien nodig; geeft terug of er nieuw aangemaakt is.',
                params: [
                    { key: 'employeeId', label: 'Employee Id (GUID)', type: 'text', value: null }
                ]
            },
            {
                name: 'Get Twinfield Articles',
                method: 'GET',
                path: 'articles',
                description: 'Haal artikelen op uit Twinfield.',
                params: []
            },
            {
                name: 'Get Twinfield Customers',
                method: 'GET',
                path: 'customers',
                description: 'Haal debiteuren op uit Twinfield.',
                params: []
            }
        ];
    }

    selectEndpoint = (endpoint: any) => {
        this.selectedEndpoint = endpoint;
        this.endpointParams = {};
        this.result = null;
        this.error = null;

        if (endpoint.params) {
            endpoint.params.forEach((param: any) => {
                this.endpointParams[param.key] = param.value;
            });
        }
    }

    callEndpoint = () => {
        if (!this.selectedEndpoint) {
            return;
        }

        this.loading = true;
        this.result = null;
        this.error = null;

        let path = this.selectedEndpoint.path;
        let queryParams: any = {};

        if (this.selectedEndpoint.params) {
            this.selectedEndpoint.params.forEach((param: any) => {
                if (path.includes(`{${param.key}}`)) {
                    path = path.replace(`{${param.key}}`, this.endpointParams[param.key]);
                } else if (this.endpointParams[param.key] !== null && this.endpointParams[param.key] !== undefined && this.endpointParams[param.key] !== '') {
                    queryParams[param.key] = this.endpointParams[param.key];
                }
            });
        }

        this.TwinfieldTestService.customGet(path, queryParams)
            .then((response: any) => {
                this.result = response;
                this.loading = false;
            })
            .catch((error: any) => {
                this.error = (error.data && error.data.message) || error.statusText || 'An error occurred';
                this.result = null;
                this.loading = false;
            });
    }

    formatJson = (obj: any) => {
        if (!obj) {
            return '';
        }

        if (typeof obj === 'string') {
            try {
                obj = JSON.parse(obj);
            } catch (e) {
                return obj;
            }
        }

        return JSON.stringify(obj, null, 2);
    }
}

export const twinfieldTestComponent: ng.IComponentOptions = {
    controller: TwinfieldTestController,
    template: <string>require('./twinfieldTest.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/twinfieldTest/twinfieldTest.component.ts